function resolveApiBase() {
  // Browser: always same-origin so admin session cookies work (CRA dev proxy + Cloudflare _redirects).
  if (typeof window !== "undefined") {
    return "/api/v1";
  }

  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv !== undefined && String(fromEnv).trim() !== "") {
    return String(fromEnv).replace(/\/$/, "");
  }
  return "/api/v1";
}

const API_BASE = resolveApiBase();

class ApiError extends Error {
  constructor(message, { status, code, details } = {}) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

/**
 * @param {string} path
 * @param {RequestInit} [options]
 */
export async function apiFetch(path, options = {}) {
  const url = `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
  const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
  const headers = {
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...(options.headers || {}),
  };

  const response = await fetch(url, {
    credentials: "include",
    ...options,
    headers,
  });

  let body = null;
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    body = await response.json();
  }

  if (!response.ok) {
    const message =
      body?.error?.message || "Something went wrong — try again in a moment.";
    throw new ApiError(message, {
      status: response.status,
      code: body?.error?.code,
      details: body?.error?.details,
    });
  }

  return body;
}

/**
 * Public GET requests (no session cookie). Use for homepage content feeds.
 *
 * @param {string} path
 * @param {RequestInit} [options]
 */
export async function apiFetchPublic(path, options = {}) {
  return apiFetch(path, { ...options, credentials: "omit" });
}

export { API_BASE, ApiError };
